import { ReactNode, useEffect, useState } from 'react'

import { useSession } from '@signavio/effektif-api'
import {
  CSSVariablesProvider,
  DevTool,
  ThemeT,
} from '@signavio/effektif-commons'
import { FlatButton, ThemeProvider, useStyles } from '@signavio/ui'
import { Stack } from '@signavio/ui/core'

import availableThemes from '../available_themes'

function OrganizationThemeProvider({ children }: { children: ReactNode }) {
  const styles = useStyles(defaultStyles, {})
  const [theme, setTheme] = useState<ThemeT>()
  const [themeName, setThemeName] = useState('fioriMorningHorizon')
  const [showThemeSelect, setShowThemeSelect] = useState(false)

  const session = useSession()

  useEffect(() => {
    if (session.sessionState === 'loggedIn' && session.organization.customCSS) {
      setThemeName(session.organization.customCSS)
    }
  }, [session])

  useEffect(() => {
    import(`../themes/${themeName}/index`)
      .then((theme) => setTheme(theme as ThemeT))
      .catch(() => {
        void import(`../themes/fioriMorningHorizon/index`).then((theme) =>
          setTheme(theme as ThemeT)
        )
      })
  }, [themeName])

  if (!theme) {
    return null
  }

  return (
    <ThemeProvider theme={theme} withFioriStyles>
      <CSSVariablesProvider>
        <>{children}</>
      </CSSVariablesProvider>
      <DevTool>
        {showThemeSelect ? (
          <Stack spacing="xsmall">
            <div {...styles('select')}>
              <select
                value={themeName}
                onChange={(event) => {
                  setThemeName(event.target.value)
                }}
              >
                {availableThemes.map((theme) => (
                  <option key={theme} value={theme}>
                    {theme}
                  </option>
                ))}
              </select>

              <FlatButton onClick={() => setShowThemeSelect(false)}>
                Hide
              </FlatButton>
            </div>
          </Stack>
        ) : (
          <FlatButton small onClick={() => setShowThemeSelect(true)}>
            Change theme
          </FlatButton>
        )}
      </DevTool>
    </ThemeProvider>
  )
}

const defaultStyles = {
  select: {
    display: 'flex',
  },
}

export default OrganizationThemeProvider
